export class Payout {
  constructor(objInit) {
    this.id = objInit.id;
    this.date = objInit.date;
    this.amount = objInit.amount;
    this.localAmount = objInit.localAmount;
    this.allocations = objInit.allocations;
    this.comment = objInit.comment;
    this.currency = objInit.currency;
    this.paymentProvider = objInit.paymentProvider;
  }
}
